import Utils from './Utils';

/** @returns {number} */
export function vote_max_score(votes_config) {
    const max_score = Number(votes_config?.max_score);
    return Number.isFinite(max_score) && max_score > 0 ? max_score : 5;
}

/** @returns {number} */
export function vote_step(votes_config) {
    const step = Number(votes_config?.step);
    return Number.isFinite(step) && step > 0 ? step : 0.5;
}

/** @returns {boolean} */
export function votes_enabled(setting) {
    return setting?.votes?.enabled === true;
}

/** @returns {boolean} */
export function screening_votes_enabled(setting, screening) {
    return votes_enabled(setting) && !screening?.opaque?.disable_votes;
}

/** @returns {number} */
export function vote_score_decimals(step) {
    if (!Number.isFinite(step) || step >= 1)
        return 0;
    const parts = String(step).split('.');
    return parts[1]?.length || 1;
}

/** @returns {number} */
export function normalize_vote_score(score, step) {
    const decimals = vote_score_decimals(step);
    return Number(Number(score).toFixed(decimals));
}

/** @returns {string} */
export function format_vote_score_label(score, step, language) {
    return Utils.formatNumber(normalize_vote_score(score, step), language);
}

/**
 * @param {object[]} tickets
 * @param {string} screening_id
 * @param {object|null|undefined} votes_config
 * @returns {{ count: number, total: number, average: number, max_score: number, step: number, distribution_rows: object[], distribution_bar: object[], has_distribution: boolean }}
 */
export function aggregate_screening_vote_stats(tickets, screening_id, votes_config) {
    const max_score = vote_max_score(votes_config);
    const step = vote_step(votes_config);
    const by_score = {};
    let count = 0;
    let total = 0;

    (tickets || []).forEach((ticket) => {
        const bookings = ticket.bookings?.filter(
            (b) => !!b.confirmed_at && b.screening?._id === screening_id
        ) || [];
        bookings.forEach((booking) => {
            const score = Number(booking.vote?.score);
            if (!Number.isFinite(score))
                return;
            const key = String(normalize_vote_score(score, step));
            count += 1;
            total += score;
            by_score[key] = (by_score[key] || 0) + 1;
        });
    });

    const distribution_rows = [];
    const epsilon = step / 1000;
    for (let score = 0; score <= max_score + epsilon; score += step) {
        const normalized = normalize_vote_score(score, step);
        const key = String(normalized);
        const row_count = by_score[key] || 0;
        distribution_rows.push({
            id: key,
            score: normalized,
            label: key,
            count: row_count,
            pct: count > 0 ? (row_count / count) * 100 : 0,
        });
    }

    distribution_rows.sort((a, b) => a.score - b.score);

    return {
        count,
        total,
        average: count > 0 ? total / count : 0,
        max_score,
        step,
        distribution_rows,
        distribution_bar: distribution_rows.map((row) => ({
            id: row.label,
            votes: row.count,
        })),
        has_distribution: count > 0,
    };
}
